import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import RedeemOutlinedIcon from "@mui/icons-material/RedeemOutlined";
import NorthWestOutlinedIcon from "@mui/icons-material/NorthWestOutlined";
import { numberSeparator } from "@/hooks/useThousandsSeparator";
import { SunIcon } from "@/shared/components/common/icons";
/**
 * walletCardsData
 *
 * این تابع مجموعه‌ای از داده‌های مربوط به کارت‌های نمایش موجودی کیف پول را تولید می‌کند.
 * این داده‌ها برای رندرکردن کارت‌های داشبورد کیف پول مورد استفاده قرار می‌گیرند.
 *
 * ویژگی‌ها:
 * - دریافت موجودی‌ها از شیء ورودی `dataAssets`.
 * - فرمت‌کردن مقادیر عددی با جداکننده هزارگان.
 * - تعیین آیکون، عنوان، مقدار، و وضعیت هر کارت.
 * - پشتیبانی از کارت‌های دارای نمودار (برای موجودی هدیه).
 *
 * کارت‌ها شامل موارد زیر هستند:
 * - موجودی نقدی کیف پول
 * - موجودی هدیه (به همراه نمودار درصدی)
 * - اعتبارات ۲۰ کارت سررسید شده
 * - موجودی اعتباری قابل برداشت
 * - موجودی نقدی داخلی
 * - اعتبارات داخلی کسب‌وکار
 *
 * @param dataAssets داده‌های دریافتی شامل انواع موجودی‌ها
 * @returns Array<Object> آرایه‌ای از داده‌های کارت برای استفاده در UI
 */

export const walletCardsData = ({ dataAssets }: { dataAssets: any }) => {
  return [
    {
      id: "1",
      title: "موجودی نقدی کیف پول",
      amount: `${numberSeparator(dataAssets?.all ? dataAssets?.all?.wallet : dataAssets?.pazirande[0]?.wallet)} ریال`,
      icon: <CreditCardOutlinedIcon />,
      link: "/wallet-balance-reports",
      buttonText: "مشاهده جزئیات",
    },
    {
      id: "2",
      title: "موجودی هدیه",
      icon: <RedeemOutlinedIcon />,
      iconLink: <NorthWestOutlinedIcon  sx={{width:"18",height:"18"}}/>,
      amount: `${numberSeparator(dataAssets?.all ? dataAssets?.all?.gift : dataAssets?.pazirande[0]?.gift) } ریال`,
      hasChart: true,
      chartValue:dataAssets?.all ? dataAssets?.all?.gift : dataAssets?.pazirande[0]?.gift,
      chartPercent: 75, 
    },

    {
      id: "3",
      title: "اعتبارات پولی پی (سر رسید نشده)",
      icon: <SunIcon />,
      amount: `${numberSeparator(dataAssets?.all ? dataAssets?.all?.sumNotReached : dataAssets?.pazirande[0]?.sumNotReached)} ریال`,
      link: "/wallet-credit-balance-reports",
      buttonText: "مشاهده جزئیات",
    },
    {
      id: "6",
      title: "موجودی اعتباری کیف پول (قابل برداشت)",
      amount: `${numberSeparator(dataAssets?.all ? dataAssets?.all?.sumReached : dataAssets?.pazirande[0]?.sumReached)} ریال`,
      icon: <CreditCardOutlinedIcon />,
      link: "/wallet-credit-balance-reports",
      buttonText: "مشاهده جزئیات",
    },

    {
      id: "5",
      title: "موجودی نقدی داخلی",
      amount: `${numberSeparator(dataAssets?.all ? dataAssets?.all?.sumCacheInner : dataAssets?.pazirande[0]?.sumCacheInner)} ریال`,
      icon: <CreditCardOutlinedIcon />,
      link: "/internal-reports-inventory",
      buttonText: "مشاهده جزئیات",
    },
    {
      id: "4",
      title: "اعتبارات داخلی کسب و کار",
      amount: `${numberSeparator(dataAssets?.all ? dataAssets?.all?.sumCreditInner : dataAssets?.pazirande[0]?.sumCreditInner)} ریال`,
      icon: <SunIcon />,
      buttonText: "مشاهده جزئیات",
    },
  ];
};
